function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getValidationWithDefaults } from "./getValidationWithDefaults";
import { getIsRequiredError } from "./getIsRequiredError";
import { getIsValidError } from "./getIsValidError";
export var getErroredState = function getErroredState(inputValidation, inputState) {
  var _getValidationWithDef = getValidationWithDefaults(inputValidation),
      isRequiredMessage = _getValidationWithDef.isRequiredMessage,
      isRequired = _getValidationWithDef.isRequired,
      invalidMessage = _getValidationWithDef.invalidMessage,
      getIsValid = _getValidationWithDef.getIsValid,
      getIsEmpty = _getValidationWithDef.getIsEmpty;

  var isRequiredError = getIsRequiredError({
    isRequired: isRequired,
    getIsEmpty: getIsEmpty
  }, inputState, isRequiredMessage);
  var isValid = !getIsEmpty(inputState.value) && getIsValid(inputState.value);
  var isValidError = getIsValidError(inputState.value, isValid, invalidMessage);
  var error = isRequiredError ? isRequiredMessage : isValidError;
  return _objectSpread(_objectSpread({}, inputState), {}, {
    isValid: isValid,
    error: error
  });
};